import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import FormGroupWrapper from "../Wrappers/FormGroupWrapper";
import { formGroupSelectDefaultProps, formGroupSelectPropTypes, renderFormGroupCommonPropTypes } from "../FormGroupCommonPropTypes";
var RenderSelect = function RenderSelect(props) {
  var input = props.input,
    placeholderOption = props.placeholderOption,
    options = props.options,
    classConfig = props.classConfig,
    disabled = props.disabled;
  return /*#__PURE__*/React.createElement(FormGroupWrapper, props, /*#__PURE__*/React.createElement("select", _extends({}, input, {
    className: classConfig.selectField || 'form-control',
    id: input.name,
    disabled: disabled
  }), placeholderOption && /*#__PURE__*/React.createElement("option", {
    value: ""
  }, placeholderOption), options.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      key: option.id,
      value: option.id
    }, option.label);
  })));
};
RenderSelect.propTypes = _objectSpread(_objectSpread({}, renderFormGroupCommonPropTypes), formGroupSelectPropTypes);
RenderSelect.defaultProps = _objectSpread({}, formGroupSelectDefaultProps);
export default RenderSelect;